import React, { ReactElement } from 'react';
import MobileNavBar from './MobileNavBar';
import DesktopNavBar from './DesktopNavBar';

const NavBar: React.FC = (): ReactElement => {
  return (
    <>
      <MobileNavBar />
      <DesktopNavBar />
    </>
  );
};

export default NavBar;
